import {
  renderRequiredRule,
  renderValidator,
  renderLengthFieldRule,
  checkValidityInn,
} from "@/utils/renderRulesForm";

import {
  checkStorage
} from "@/utils/baseFunctions";

import { useDataFormStore } from "@/stores/form";

export default (consignee) => ({
  cityTo: [renderRequiredRule("Пожалуйста выберите город")],
  officeTo: [
    renderRequiredRule(""), 
    renderValidator({
      validatorFunc: ()=>!checkStorage('to'),
      message: '',
    })
  ],
  consigneeType: [],
  innConsignee: [
    renderRequiredRule("Пожалуйста введите ИНН"),
    renderValidator({
      validatorFunc: checkValidityInn,
      message: "Некорректно введён ИНН",
    }),
    {
      validator: (rule, value, callback) => {
        if (!value) return callback();
        if (consignee.consigneeType === 1 && value.length !== 10) {
          callback(new Error("Для юр. лица ИНН должен состоять из 10 символов"));
        } else if (consignee.consigneeType === 2 && value.length !== 12) {
          callback(new Error("Для ИП ИНН должен состоять из 12 символов"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
  kppConsignee: [
    renderRequiredRule("Пожалуйста введите КПП"),
    renderLengthFieldRule({
      min: 9,
      max: 9,
      message: "КПП должен состоять из 9 символов",
    }),
  ],
  name: [
    renderRequiredRule("Пожалуйста введите название организации"),
  ],
  surnameConsignee: [
    renderRequiredRule("Введите фамилию"),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 2),
        message: "Слишком коротко",
    }),
  ],
  firstNameConsignee: [
    renderRequiredRule("Введите имя"),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 1),
        message: "Слишком коротко",
    }),
  ],
  secondNameConsignee: [
    renderRequiredRule("Введите отчество"),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 1),
        message: "Слишком коротко",
    }),
  ],
  phoneConsignee: [
    renderRequiredRule("Пожалуйста введите телефон"),
    renderValidator({
      validatorFunc: (value) =>
        !!value.match(/^\+{0,1}\d \([3,4,6-9]\d{2}\) \d{3}-\d{2}-\d{2}$/),
      message: "Некорректно введён номер",
    }),
  ],
  emailConsignee: [
    {
      validator: (rule, value, callback) => {
        const dataForm = useDataFormStore();
        if (
          (consignee.consigneeType && (value === "")) ||
          (dataForm.emailNotification && (value === "")) ||
          (!(value === "") && !value.match(/^([a-zA-Z0-9_-]+\.)*[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,6}$/))
        ) {
          callback(new Error("Пожалуйста введите почту"));
        }

        callback();
      },
      trigger: "blur",
    },
  ],
});
